import React from 'react'
import AllTransactionsComponent from '../../../Components/AdminComponent/AllTransactionsComponent/AllTransactionsComponent'
import AdminSidebar from '../../../Components/AdminComponent/AdminSidebar/AdminSidebar'
import AdminHeader from '../../../Components/AdminComponent/AdminHeader/AdminHeader'

const AllTransactions = () => {
    return (
        <div>
            <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <AdminHeader />
                <div className='row col-lg-12'>
                    <AdminSidebar />
                    <div className='col-lg-10 right_content'>
                        <AllTransactionsComponent />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllTransactions
